import { ClientOptions, ClientVendors } from 'src/common-services/types/client-types'
import { PropertiesClient } from 'src/common-services/clients/vendors/properties'

export function initializeVendors(options: ClientOptions): ClientVendors {
  return {
    properties: new PropertiesClient(options),
  }
}
